<div class="query-delete">
  <h2 class="qd-title">Delete “{{ data.query.name }}”?</h2>

  <p class="qd-text" *ngIf="otherCollections.length === 0">
    This permanently deletes the query.
  </p>
  <p class="qd-text" *ngIf="otherCollections.length > 0">
    It is also in
    <strong>{{ otherCollections.join(', ') }}</strong
    >. You can remove it from this collection only, or delete it everywhere.
  </p>

  <div class="qd-warning" *ngIf="usedBy.length > 0">
    <mat-icon>warning_amber</mat-icon>
    <div>
      <div>
        Used by
        <ng-container *ngFor="let ref of usedBy; let last = last">
          {{ ref.kind }} <strong>{{ ref.name }}</strong
          >{{ last ? '.' : ', ' }}
        </ng-container>
      </div>
      <div class="qd-muted">Deleting the query also removes it there.</div>
    </div>
  </div>

  <div class="qd-actions">
    <button mat-stroked-button class="qd-cancel" mat-dialog-close>
      Cancel
    </button>
    <button
      *ngIf="otherCollections.length > 0"
      mat-stroked-button
      class="qd-remove"
      [mat-dialog-close]="'remove'"
    >
      Remove from this collection
    </button>
    <button mat-flat-button class="qd-delete" [mat-dialog-close]="'delete'">
      {{ otherCollections.length > 0 ? 'Delete everywhere' : 'Delete' }}
    </button>
  </div>
</div>
